export const columns = [
  {
    title: "材料名称",
    width: 200,
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "品牌",
    width: 200,
    dataIndex: "materialBrand",
    key: "materialBrand",
  },
  {
    title: "规格型号",
    width: 200,
    dataIndex: "materialModel",
    key: "materialModel",
  },
];
